import axios from 'axios';
import config from '../../../../helpers/config';
import { sites } from '../../../../helpers/globalVariables';

export default function setMandiAddress(address, requiresConfirmation) {
  const normalizedBy = requiresConfirmation ? 0 : 1;

  // Default the property name for home depot because it is required
  const propertyName = config.siteId === sites.theHomeDepot ? 'Home 1' : '';

  const url = config.mandiBaseUrl + config.setAddressApi;
  const payload = {
    address: {
      ...address,
      normalizedBy,
    },
    newPropertyName: propertyName,
  };

  return axios.post(url, payload, {
    withCredentials: true,
  });
}
